import { Link } from "react-router-dom";

interface SectionHeadProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHead({ eyebrow, title, desc, actionLabel, actionTo }: SectionHeadProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between md:mb-8">
      <div className="min-w-0">
        {eyebrow ? (
          <p className="mb-1.5 flex items-center gap-2 font-heading text-[10px] uppercase tracking-[0.28em] text-primary-500">
            <span className="inline-block h-px w-6 bg-primary-600" />
            {eyebrow}
          </p>
        ) : null}
        <h2 className="font-heading text-xl font-bold text-foreground-50 md:text-2xl">{title}</h2>
        {desc ? <p className="mt-1.5 max-w-2xl text-[12px] leading-relaxed text-foreground-500 md:text-[13px]">{desc}</p> : null}
      </div>
      {actionLabel && actionTo ? (
        <Link
          to={actionTo}
          className="flex w-fit cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300/70 px-3 py-2 text-[12px] text-foreground-300 transition hover:border-primary-600/70 hover:text-primary-300"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      ) : null}
    </div>
  );
}